import { createClient } from '@supabase/supabase-js'

const supabaseUrl = "https://iiswrqblcgrebbyrltat.supabase.co"
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imlpc3dycWJsY2dyZWJieXJsdGF0Iiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc4MDE1OTg5MiwiZXhwIjoyMDk1NzM1ODkyfQ.r2pC9a8LdQoY58EFZHY3hjQEfkYf_3sXN95jkbYKNh8"

export const supabase = createClient(supabaseUrl, supabaseKey)
